import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  targetDate: Date;
  className?: string;
}
export function CountdownTimer({
  targetDate,
  className = ''
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = +targetDate - +new Date();
      let newTimeLeft = {
        hours: 0,
        minutes: 0,
        seconds: 0
      };
      if (difference > 0) {
        newTimeLeft = {
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        };
      }
      return newTimeLeft;
    };
    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, [targetDate]);
  const formatTime = (time: number) => {
    return time < 10 ? `0${time}` : time;
  };
  return <span className={`font-mono font-bold tracking-wider text-white ${className}`} data-id="element-14">
      {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
      {formatTime(timeLeft.seconds)}
    </span>;
}